import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Type, Box } from '@nerdwallet/currency';
import { NumStepper } from '@nerdwallet/react-stepper';

import { ENTITY_NAME, MORTGAGE } from '../../../../lib/analytics-constants';
import { validationsSelector } from '../../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../../lib/selectors/mortgage-calculator';
import {
  MortgageInput,
  formatYears,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';
import useAnalytics from '../../../../lib/analytics/use-analytics';

import styles from './loan-term-input.module.less';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

type onInputChange = OnChangeEvent | number;

const LoanTermInput: React.FC<MortgageInput> = ({
  manualInputs,
  inputs,
  dispatch,
  analytics,
}) => {
  const segmentAbstract = useAnalytics();
  // if inputType is RANGE we need to set a default value, so taking placeholder if needed
  const placeholder = inputs?.loanTerm;
  const value = manualInputs?.loanTerm ?? placeholder;
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: onInputChange) => {
    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_type: 'increment-decrement-user_type_input',
        entityName: 'loan_term',
        field: 'Loan Term',
        field_value: e,
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'loanTerm',
      calculator: MORTGAGE,
      inputType: 'number',
    });
  };

  return (
    <Box>
      <Type size="1">
        Loan term
        <Tooltip
          placement="top"
          content="The amount of time you have to pay back the loan. Usually 15 or 30 years for common loan types."
          analytics={{
            entityName: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            eventType: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            payload: {
              additional_attributes: {
                help_button_location: 'loan_term',
              },
            },
          }}
        />
      </Type>
      <Box className={styles.numStepperWrapper}>
        <NumStepper
          editable
          formatter={formatYears}
          max={30}
          min={1}
          stepSize={1}
          value={value}
          onChange={onInputChange}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(LoanTermInput);
